
import CloseIcon from '../icons/CloseIcon.vue';
import AlertIcon from '~/components/ui/icons/AlertIcon.vue';
import CustomDrawer from '@/components/ui/molecule/CustomDrawer';
export default {
  name: 'UnrankedPortfolioConfirmationDrawer',
  components: { CustomDrawer, CloseIcon, AlertIcon },
  props: {
    isPublic: {
      type: Boolean,
      default: false,
    },
    itemCountCondition: {
      type: Boolean,
      default: false,
    },
    allocationCondition: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      show: true,
    };
  },
  mounted() {
    this.show = true;
  },
  methods: {
    handleConfirm() {
      this.$emit('confirm');
    },
    handleClose() {
      this.show = false;
      setTimeout(() => {
        this.$emit('close');
      }, 100);
    },
  },
};
